import controller from './gauge-chart.controller';
import template from './gauge-chart.html';

export default {
	template,
	bindings: {
		data: '<',
		options: '<',
		total: '<',
	},
	controller,
};
